<template>
    <div class="quality_page page">
        <div class="top_bg">
            <!--      <img src="../assets/quality_bg.png">-->
            <img :src="banner?api+banner:require('../assets/download_bg.png')">
        </div>

        <b-container class="quality_content my_content">
            <p class="title">{{ pageData.name }}</p>

            <div class="text-center" v-html="pageData.content"></div>

        </b-container>
    </div>
</template>

<script>

    import {singleDetail} from '../api/HomeService'
    import {api} from '../api/api';

    export default {
        name: "Quality",
        data() {
            return {
                languageNum: window.localStorage.getItem("languageNum"),
                pageData: {},
                title: '',
                banner: '',
                api: api
            }
        },
        methods: {
            getPageData() {
                let sendData = {
                    languageNum: this.languageNum,
                    type: 1
                }
                singleDetail(sendData, data => {
                    this.pageData = data[0];
                    console.log(this.pageData)
                })
            }
        },
        mounted() {
            let menuList = JSON.parse(window.localStorage.getItem('menuList'));
            for (let i = 0; i < menuList.length; i++) {
                if (menuList[i].children) {
                    for (let j = 0; j < menuList[i].children.length; j++) {
                        if (this.$route.path.indexOf(menuList[i].children[j].menuUrl) > 0) {
                            this.title = menuList[i].children[j].title
                            this.banner = menuList[i].children[j].banner
                        }
                    }
                }
            }
            this.getPageData();
        }
    }
</script>

<style scoped src="../css/quality.scss" lang="scss">

</style>